import styled from 'styled-components';

import { IDetailPageThumbnailProps } from 'src/pages/DetailPage/components/DetailPageThumbnailBar.i';
import { Button } from '@riac/design-system';


export const DetailPageThumbnailsSection = styled.div`
  width: 100%;
`;

export const DetailPageThumbnailsContainer = styled.div<Partial<IDetailPageThumbnailProps>>`
  width: calc(100% + ${({ margin }) => margin}px);
  margin: -${({ margin }) => margin / 2}px;
  padding-top: 14px;
  overflow: visible;
`;

export const DetailPageThumbnail = styled(Button)<IDetailPageThumbnailProps>`
  &,&>img:first-child {
    height: ${({ width }) => width}px;
    width: ${({ width }) => width}px;
  }
  margin: ${({ margin }) => margin / 2}px;
  padding: 0;
  
  transition: transform 300ms;
  transform: scale(1);

  box-shadow:
    0 4px 5px 0 rgb(0 0 0 / 14%), 0 1px 10px 0 rgb(0 0 0 / 12%), 0 2px 4px -1px rgb(0 0 0 / 20%);

  &:hover {
    transform: scale(1.07);
    transition: transform 150ms;
    box-shadow: 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%), 0 3px 5px -1px rgb(0 0 0 / 20%);
  }

  &,&:hover {
    ${({ active }) => active && `
      box-shadow: 0 0 15px 5px rgb(240 188 40 / 90%);
      transform: scale(1.14);
    ` || ''}

    @media print {
      transform: scale(1);
      box-shadow: none;
    }
  }

  &>svg {
    z-index: 1;
    color: white;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    text-align: center;
    margin: auto;
    background-color: black;
    border-radius: 50%;
    padding: 1px;
    font-size: 4rem;
  }
`;

export const DetailPageThumbnailBarLotExtensionContainer = styled.div`
  display: flex;
  flex-direction: column;
  &>div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
`;
